function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { StyledProductCardsGridDesktopComponent } from "./product-cards-grid-desktop-component.scss";
import ProductCardGridDekstopComponent from "./product-card-grid-component/product-card-grid-dekstop-component";
import DefaultProps from "./default-props";
import { MARKETER_PRODUCT_TYPE, PROJECTS_PRODUCT_TYPE } from "constants/products";
const ProductCardsGridDekstopComponent = (props)=>{
    var _cards_map;
    const { cards } = props;
    const isAtLeastOneCardHighlighted = cards === null || cards === void 0 ? void 0 : (_cards_map = cards.map((card)=>card === null || card === void 0 ? void 0 : card.isHighlighted)) === null || _cards_map === void 0 ? void 0 : _cards_map.reduce((previousValue, currentValue)=>previousValue || currentValue, false);
    return /*#__PURE__*/ _jsx(StyledProductCardsGridDesktopComponent, {
        className: "product-cards-grid-desktop-component",
        children: cards === null || cards === void 0 ? void 0 : cards.filter((card)=>card.productType !== MARKETER_PRODUCT_TYPE && card.productType !== PROJECTS_PRODUCT_TYPE).map((card, index)=>/*#__PURE__*/ _jsx(ProductCardGridDekstopComponent, _object_spread_props(_object_spread({}, card), {
                isAtLeastOneCardHighlighted: isAtLeastOneCardHighlighted
            }), index))
    });
};
ProductCardsGridDekstopComponent.defaultProps = DefaultProps;
export default ProductCardsGridDekstopComponent;
